/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import NewValuesSlider from './NewValuesSlider/NewValuesSlider';

import { useRecoilState } from 'recoil';
import { isClientWidthState } from '../../../store/atoms';

import styled from 'styled-components';

export default function CoreValue() {
  const [isClientWidth, setIsClientWidth] = useRecoilState(isClientWidthState);

  const getClientWidth = () => {
    return document.documentElement.clientWidth;
  };

  const handleWidthSize = () => {
    setIsClientWidth(getClientWidth());
  };

  useEffect(() => {
    window.addEventListener('resize', handleWidthSize);
    return () => {
      window.removeEventListener('resize', handleWidthSize);
    };
  }, []);

  return (
    <StyledCoreValue>
      <StyledTag>OUR CORE VALUES</StyledTag>
      {getClientWidth() > 750 && isClientWidth >= 0 && (
        <StyledCoreValueContainer>
          <StyledValue>
            <StyledValueTitle>SMART 현명함</StyledValueTitle>
            <StyledValueSubtitle>Smart</StyledValueSubtitle>
            <p>
              성공적인 투자를 위해서는 단순한 "똑똑함"을 넘어서는 <br />
              "현명함"이 필요합니다. 기계가 가진 똑똑함은 사람을 능가하지만,
              <br />
              결코 기계는 스스로 현명해질 수는 없습니다. <br />
              우리는 사람만이 갖출 수 있는 현명함이 가진 힘을 믿습니다.
            </p>
          </StyledValue>
          <StyledValue>
            <StyledValueTitle>INTEGRITY 진실됨</StyledValueTitle>
            <StyledValueSubtitle>Integrity</StyledValueSubtitle>
            <p>
              "지능과 열정만 있고 진실성이 없는 직원은 최악이다."
              <br />
              전설적인 투자자 ‘워런 버핏’이 남긴 말입니다.
              <br />
              우리는 진실된 마음을 가진 자만이 지능과 열정의 힘을 빌어
              <br />
              세상을 더 나은 곳으로 바꿀 수 있다고 믿습니다.
            </p>
          </StyledValue>
          <StyledValue>
            <StyledValueTitle>PROFESSIONAL 전문성</StyledValueTitle>
            <StyledValueSubtitle>Professional</StyledValueSubtitle>
            <p>
              겉으로 보이는 성공적인 성과에는 겉으로는 보이지 않는
              <br /> 치열하게 고민해야만 만들어낼 수 있는 디테일들이 숨어
              있습니다.
              <br /> 우리는 그 어떤 똑똑한 알고리즘도 결국 치열하게 고민하는
              사람의
              <br /> 머리와 손에 의해 완성된다는 것을 믿습니다.
            </p>
          </StyledValue>
        </StyledCoreValueContainer>
      )}
      {getClientWidth() <= 750 && isClientWidth >= 0 && <NewValuesSlider />}
    </StyledCoreValue>
  );
}

const StyledCoreValue = styled.article`
  padding-top: 70px;
  position: relative;
`;

const StyledTag = styled.h2`
  max-width: 1340px;
  padding: 0 30px;
  margin: 0 auto 18px;
  color: ${({ theme }) => theme.colors.green};

  ${({ theme }) => theme.mobile`
    margin-bottom: 10px;
    text-align: center;
  `}
`;

const StyledCoreValueContainer = styled.ul`
  max-width: 1920px;
  margin: 0 auto;
  ${({ theme }) => theme.flex('row', 'center', 'stretch')};

  li:last-child {
    border-right: none;
  }
`;

const StyledValue = styled.li`
  width: 33%;
  padding: 4%;
  flex-grow: 1;
  background-color: rgba(40, 222, 44, 0.1);
  border-right: 1px solid ${({ theme }) => theme.colors.black};
`;

const StyledValueTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.pixelToVw(200)};
  font-weight: 700;
`;

const StyledValueSubtitle = styled.div`
  margin-bottom: 18px;
  font-size: 30px;
  font-weight: 700;
`;
